import Vue from 'vue'

/* eslint-disable no-new */
new Vue({
  el: '#app'
})



// WEBPACK FOOTER //
// ./src/framework/common/index.js